import React from 'react';
import styled from 'styled-components';

import hourglass from '../../assets/images/svg/hourglass.svg';

interface ModalProps {
  isShow: boolean;
  onClose: () => void;
}

const Overlay = styled.div<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;
const ModalContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  position: relative;
  z-index: 9999;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;

const ImageHourglass = styled.img``;

const ModalTitle = styled.h3`
  margin-top: 1rem;
  font-weight: 600;
  font-size: 24px;
  color: #1dc14b;
`;
const ModalText = styled.p``;

const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0.5rem;
  margin-top: 3rem;
`;

const ButtonClose = styled.button`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  color: #ffffff;
  background: #1dc14b;
  box-sizing: border-box;
  border-radius: 4px;
  border: solid 1px #1dc14b;
  padding: 0.5rem 4rem;
  cursor: pointer;
`;

const ModalLogoutInactivity: React.FC<ModalProps> = ({
  isShow = true,
  onClose,
}) => {
  return (
    <Overlay isShow={isShow}>
      <ModalContainer>
        <ModalBody>
          <ImageHourglass src={hourglass} alt="hourglass" />
          <ModalTitle>Lo sentimos</ModalTitle>
          <ModalText>Su sesión a expirado.</ModalText>
        </ModalBody>
        <ModalFooter>
          <ButtonClose onClick={onClose}>Aceptar</ButtonClose>
        </ModalFooter>
      </ModalContainer>
    </Overlay>
  );
};

export default ModalLogoutInactivity;
